var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgIcondevicessquaresamjinMotionsolid = function SvgIcondevicessquaresamjinMotionsolid(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "80px",
    height: "80px",
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/Devices/icon.devices.square.samjin_motion.solid") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/Devices/icon.devices.square.samjin_motion.solid",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "devices/devices.motion_sensor.front",
    transform: "translate(1, 1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39,0.5 C53.5454216,0.5 62.8153015,3.96628199 68.5951077,9.74608824 C75.676801,16.8277815 77.5,27.3414105 77.5,39 C77.5,50.5847935 75.3919202,61.0369568 68.3125345,68.1163424 C62.4524061,73.9764708 53.1977224,77.5 39,77.5 C24.8843522,77.5 15.655373,73.9157486 9.7904439,68.0508195 C2.63001776,60.8903934 0.5,50.3676979 0.5,39 C0.5,27.5612839 2.34195809,16.9759861 9.50529016,9.81265401 C15.2913895,4.02655464 24.5376798,0.5 39,0.5 Z",
    id: "Oval",
    stroke: "#666666",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    stroke: "#666666",
    fill: "#FFFFFF",
    cx: 38.5,
    cy: 39.17,
    rx: 8.16666667,
    ry: 8.21
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#B8B8B8",
    strokeWidth: 0.268273092,
    cx: 39,
    cy: 39,
    r: 19.8658635
  })))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgIcondevicessquaresamjinMotionsolid);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon.devices.square.samjin_motion.solid.db89e9c050d9a38f4801dc5772931021.svg";